import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@material-ui/core";
import './ConfirmDialog.css'

export default class ConfirmDialog extends React.Component<any, any>{
    render() {
        return (
            this.props.show ?
                <Dialog
                    id={this.props.id === undefined ? "confirm-dialog" : this.props.id}
                    open={this.props.show}
                    onClose={this.props.onClose}
                    aria-labelledby="confirm-dialog-title"
                    aria-describedby="confirm-dialog-description"
                >
                    <DialogTitle style={{marginLeft: 20, marginRight: 20}} id="confirm-dialog-title">{this.props.title}</DialogTitle>
                    <DialogContent className={"confirm-dialog-no-overflow"}>
                        <DialogContentText id="confirm-dialog-description">
                            {this.props.content}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions id={"dialog-actions-container"}>
                        <Button id={"button-no"} onClick={this.props.onClose} color="primary">
                            {this.props.buttonNoText}
                        </Button>
                        <Button id={"button-yes"} onClick={this.props.onConfirm} color="primary" autoFocus>
                            {this.props.buttonYesText}
                        </Button>
                    </DialogActions>
                </Dialog> : null
        );
    }
}